import type { ReactNode } from "react";
import { ErrorPlaceholder } from "../../../../components/common";

interface RegionStateProps {
  isLoading: boolean;
  error?: string | null;
  onRetry?: () => void;
  skeleton: ReactNode;
  children: ReactNode;
}

/**
 * Renders one dashboard region in exactly one state.
 * Loading always replaces the region content with its skeleton so every
 * initial load, filter apply, and retry is visible in place. Errors block
 * only the failed region and expose the owning query's retry callback.
 */
export function RegionState({ isLoading, error, onRetry, skeleton, children }: RegionStateProps) {
  if (isLoading) {
    return <>{skeleton}</>;
  }

  if (error) {
    return (
      <div
        className="flex flex-1 flex-col justify-center"
        data-testid="region-error"
      >
        <ErrorPlaceholder
          error={error}
          onRetry={onRetry}
        />
      </div>
    );
  }

  return <>{children}</>;
}
